// extracted by mini-css-extract-plugin
export default {"backTop":"backTop__8366e347"};